<template>
  <div class="alxq2">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
        <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd bxz">合作案例</div>
        <div @click="ydd(hsk)" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img
                  src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg"
                  alt=""
                />
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox"></div>
    <div class="alxqboxbox">
      <div class="alxqbox">
        <div class="text text1">2021 - 6 - 16</div>
        <div class="text text2">
          爆品营销|连锁酒店锁客成交方案，做好引流能达85%！
        </div>
        <div class="text text3">
          一、行业导读
          <br />

          酒店遍布于各商贸圈，所处地带一般人流大，竞争也大，尤其是100-200元中低端价位的酒店，不打价格战口碑很难上去。新客户流失率大是绝大部分酒店尤其是连锁酒店的痛点。
          针对这些痛点，可以在特殊节日举办特惠锁客活动，达到快速引流锁客的目的。
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel1.30941b9.png"
            alt=""
          />
        </div>
        <div class="text text3">
          二、预期营销效果
          <br />

          1.复购率：环比增加50-100%
          <br />

          2.客户量：新增 5-10%
          <br />

          3.储值量：环比增加100%以上
          <br />

          三、配套礼品
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel2.a22d0c5.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel3.ad67c4e.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel4.b30fc3c.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel5.be8307c.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel6.28fdd10.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel7.faaa071.png"
            alt=""
          />
        </div>
        <div class="text text3">
          四、实操方案
          <br />

          方案思路：该方案成功的标准就是前期是否能做到引流，要想达到预期效果，根据经济发展程度、酒店星级、消费水平不同，考虑需有1000-5000人了解此活动，引流50%即可完成进店人数500-2500，引流成功后就交给后续的优惠活动了。
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel8.f81ff87.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel9.680a49c.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel10.8f8be2e.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel11.d8d673b.png"
            alt=""
          />
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/hotel12.df89516.png"
            alt=""
          />
        </div>
        <div class="text text3">
          本次爆品营销方案到这就结束了，只要执行力够，这样的活动一定能成功引流客户。
        </div>

        <div class="gjcanwxwbqqbox">
          <div class="gjcanwxwbqqleft"></div>
          <div class="gjcanwxwbqqright">
            <div
              @click="shareToQQ()"
              class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg1"
            ></div>
            <div
              @click="WeixinJSBridge()"
              class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg2"
            ></div>
            <div
              @click="shareToMicroblog()"
              class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg3"
            ></div>
          </div>
        </div>
        <div class="hengxian"></div>
        <div class="xgaltext">相关案例</div>
        <div class="xgalbox">
          <div @click="tiaozhuan(1)" class="xgalboxs xgalboxs1">
            <div class="xgalboxstext">饺子馆会员制简单有效促使精准回流</div>
          </div>
          <div @click="tiaozhuan(2)" class="xgalboxs xgalboxs2">
            <div class="xgalboxstext">健身俱乐部引流锁客经典案</div>
          </div>
          <div @click="tiaozhuan(3)" class="xgalboxs xgalboxs3">
            <div class="xgalboxstext">
              用2个步骤，一周新增628客户，营收91万！
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk: 1,
    };
  },
  mounted() {},
  methods: {
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        // share_url: "http://www.micreat.com/#/"
        share_url: "http://www.micreat.com?projectId=1",
      };
      // var qqqq = "https://connect.qq.com/widget/shareqq/index.html?url=" +
      var qqqq =
        "https://api.pwmqr.com/qrcode/create/?url=" +
        encodeURIComponent(share.share_url) +
        "&title=" +
        share.title +
        "&desc=" +
        share.desc;

      window.open(qqqq, "newwindow", "height=400,width=400,top=200,left=600");
    },
    //分享到QQ空间(可用)
    WeixinJSBridge() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        share_url: "http://www.micreat.com?projectId=1",
      };
      var wwww =
        "https://api.pwmqr.com/qrcode/create/?url=" +
        encodeURIComponent(share.share_url) +
        "&title=" +
        share.title +
        "&desc=" +
        share.desc;

      window.open(wwww, "newwindow", "height=400,width=400,top=200,left=600");
    },
    //分享到微博(可用)
    shareToMicroblog() {
      //自定义内容
      const share = {
        title: "米创集团",
        image_url: ["https://api.mxl.mclandian.com/images/favicon.ico"],
        share_url: "http://www.micreat.com/#/",
      };
      //跳转地址
      var bbbb =
        "https://service.weibo.com/share/share.php?url=" +
        encodeURIComponent(share.share_url) +
        "&title=" +
        share.title +
        "&pic=" +
        share.image_url +
        "&searchPic=true";

      window.open(bbbb, "newwindow", "height=1000,width=1000,top=200,left=100");
    },
    tiaozhuan(e) {
      if (e == 3) {
        this.$router.push({
          path: "/alxq5",
        });
      } else if (e == 2) {
        this.$router.push({
          path: "/alxq4",
        });
      } else if (e == 1) {
        this.$router.push({
          path: "/alxq2",
        });
      }
    },
    ydd(e) {
      if (e == 1) {
        this.hsk = 2;
      } else {
        this.hsk = 1;
      }
      console.log(this.hsk);
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.alxq2 {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1501.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
  }
  .alxqboxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 0.8rem;
    .alxqbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.1rem;
      .imgbox {
        width: 10rem;
        height: 5rem;
        background: #0f0;
        margin: 0 auto;
        margin-bottom: 0.4rem;
        background: url("../../assets/images/1625137306(1).jpg") no-repeat
          center;
      }
      .text {
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .text1 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #626262;
        margin-bottom: 0.2rem;
      }
      .text2 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        margin-bottom: 0.9rem;
      }
      .text3 {
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 0.4rem;
        margin-bottom: 0.87rem;
        
      }
      .gjcanwxwbqqbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        .gjcanwxwbqqleft {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d60fe;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .gjcanwxwbqqright {
          display: flex;
          justify-content: center;
          align-items: center;
          .gjcanwxwbqqrightimg {
            width: 0.3rem;
            height: 0.3rem;
            background-size: 100% 100%;
            margin-left: 0.5rem;
          }
          .gjcanwxwbqqrightimg1 {
            background: url("../../assets/images/qqt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg2 {
            background: url("../../assets/images/wxt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg3 {
            background: url("../../assets/images/wbt.png") no-repeat center;
          }
        }
      }
      .hengxian {
        width: 100%;
        height: 0.01rem;
        background: #efefef;
        margin-bottom: 0.8rem;
      }
      .xgaltext {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        margin-bottom: 0.5rem;
      }
      .xgalbox {
        display: flex;
        flex-wrap: wrap;
        .xgalboxs {
          width: 3.86rem;
          height: 2.89rem;
          background-size: 100% 100%;
          margin-right: 0.2rem;
          position: relative;
          .xgalboxstext {
            width: 387px;
            height: 52px;
            background: rgba($color: #010206, $alpha: 0.3);
            position: absolute;
            bottom: 0;
            display: flex;
            justify-content: left;
            align-items: center;
            padding-left: 0.15rem;
            box-sizing: border-box;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
          }
        }
        .xgalboxs1 {
          background: url("../../assets/images/a3.png") no-repeat center;
        }
        .xgalboxs2 {
          background: url("../../assets/images/a1.png") no-repeat center;
        }
        .xgalboxs3 {
          background: url("../../assets/images/a2.png") no-repeat center;
        }
        .xgalboxs:nth-child(3n) {
          margin-right: 0rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/alxq12/index.vue